import { useEffect, useState } from 'react';
import { sablonYonetimListesi, sablonYonetimOlustur, sablonYonetimSil, dosyaUrl } from '../services/api';
import SablonDuzenle from './SablonDuzenle';

// Admin panelindeki BAĞIMSIZ "Şablonlar" bölümü — işletme oluşturma akışına hiç dokunmaz.
// Kullanıcı talebi: 2026-07-26.
export default function AdminSablonlar() {
  const [sablonlar, setSablonlar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState('');

  const listeyiYenile = () => {
    setYukleniyor(true);
    sablonYonetimListesi()
      .then((res) => setSablonlar(res.data))
      .catch((err) => setHata(err.response?.data?.hata || 'Liste alınamadı.'))
      .finally(() => setYukleniyor(false));
  };

  useEffect(() => { listeyiYenile(); }, []);

  const [ekleModalAcik, setEkleModalAcik] = useState(false);
  const [yeniAd, setYeniAd] = useState('');
  const [ekleHata, setEkleHata] = useState('');
  const [ekleniyor, setEkleniyor] = useState(false);

  const sablonEkle = (e) => {
    e.preventDefault();
    setEkleHata(''); setEkleniyor(true);
    sablonYonetimOlustur(yeniAd)
      .then(() => { setEkleModalAcik(false); setYeniAd(''); listeyiYenile(); })
      .catch((err) => setEkleHata(err.response?.data?.hata || 'Kaydedilemedi.'))
      .finally(() => setEkleniyor(false));
  };

  const [silPopup, setSilPopup] = useState(null); // { sablon, adim }
  const [siliniyor, setSiliniyor] = useState(false);
  const [silHata, setSilHata] = useState('');

  const silBaslat = (sablon) => { setSilHata(''); setSilPopup({ sablon, adim: 1 }); };
  const silSonrakiAdim = () => setSilPopup((p) => ({ ...p, adim: p.adim + 1 }));
  const kalicaSil = () => {
    setSiliniyor(true); setSilHata('');
    sablonYonetimSil(silPopup.sablon.id)
      .then(() => { setSilPopup(null); listeyiYenile(); })
      .catch((err) => setSilHata(err.response?.data?.hata || 'Silinemedi.'))
      .finally(() => setSiliniyor(false));
  };

  const [duzenlenenSablon, setDuzenlenenSablon] = useState(null);
  const adGuncellendi = (id, yeniAd) => {
    setSablonlar((liste) => liste.map((s) => (s.id === id ? { ...s, ad: yeniAd } : s)));
  };

  const onizle = (sablon) => {
    window.open(`${process.env.PUBLIC_URL}/sablon-onizleme/${sablon.id}`, '_blank');
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h3 style={{ margin: 0, color: '#1e2a3a' }}>Şablonlar</h3>
        <button onClick={() => { setEkleHata(''); setYeniAd(''); setEkleModalAcik(true); }} className="btn btn-vurgu">+ Şablon Ekle</button>
      </div>

      {hata && <div className="hata-kutu">{hata}</div>}

      <div className="kart" style={{ padding: 0, overflow: 'hidden' }}>
        {yukleniyor ? (
          <div style={{ padding: 20 }}>Yükleniyor...</div>
        ) : sablonlar.length === 0 ? (
          <div style={{ padding: 20, color: '#6b7684' }}>Henüz şablon tanımlanmadı.</div>
        ) : (
          <table className="veri-tablosu">
            <thead>
              <tr>
                <th>Logo</th>
                <th>Şablon Adı</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {sablonlar.map((s) => (
                <tr key={s.id}>
                  <td>{s.logoUrl ? <img src={dosyaUrl(s.logoUrl)} alt={s.ad} style={{ width: 32, height: 32, borderRadius: '50%', objectFit: 'cover' }} /> : '—'}</td>
                  <td>{s.ad}</td>
                  <td style={{ display: 'flex', gap: 8 }}>
                    <button onClick={() => onizle(s)} className="btn btn-koyu" style={{ padding: '5px 12px', fontSize: 12 }}>Önizle</button>
                    <button onClick={() => setDuzenlenenSablon(s)} className="btn btn-koyu" style={{ padding: '5px 12px', fontSize: 12 }}>Editle</button>
                    <button onClick={() => silBaslat(s)} className="btn btn-kirmizi" style={{ padding: '5px 12px', fontSize: 12 }}>Sil</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {ekleModalAcik && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <form onSubmit={sablonEkle} className="kart" style={{ width: 380 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
              <h3 style={{ margin: 0, color: '#1e2a3a' }}>Yeni Şablon</h3>
              <button type="button" onClick={() => setEkleModalAcik(false)} className="btn btn-koyu">✕</button>
            </div>
            {ekleHata && <div className="hata-kutu">{ekleHata}</div>}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Şablon Adı</label>
                <input value={yeniAd} onChange={(e) => setYeniAd(e.target.value)} placeholder="Örn: Örnek Kebapçı" required />
              </div>
              <button type="submit" disabled={ekleniyor} className="btn btn-vurgu">{ekleniyor ? 'Oluşturuluyor...' : 'Oluştur'}</button>
            </div>
          </form>
        </div>
      )}

      {duzenlenenSablon && (
        <SablonDuzenle
          sablon={duzenlenenSablon}
          onKapat={() => setDuzenlenenSablon(null)}
          onAdGuncellendi={adGuncellendi}
        />
      )}

      {silPopup && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}>
          <div className="kart" style={{ width: 420 }}>
            {silHata && <div className="hata-kutu">{silHata}</div>}

            {silPopup.adim === 1 && (
              <>
                <h3 style={{ marginTop: 0, color: '#1e2a3a' }}>Şablonu Sil</h3>
                <p style={{ fontSize: 14 }}><strong>{silPopup.sablon.ad}</strong> şablonunu silmek istediğinize emin misiniz?</p>
                <div style={{ display: 'flex', gap: 10 }}>
                  <button onClick={() => setSilPopup(null)} className="btn btn-koyu" style={{ flex: 1 }}>Vazgeç</button>
                  <button onClick={silSonrakiAdim} className="btn btn-kirmizi" style={{ flex: 1 }}>Devam Et</button>
                </div>
              </>
            )}

            {silPopup.adim === 2 && (
              <>
                <h3 style={{ marginTop: 0, color: '#c0392b' }}>Bu İşlem Geri Alınamaz</h3>
                <p style={{ fontSize: 14 }}>
                  <strong>{silPopup.sablon.ad}</strong> şablonuna ait TÜM veriler — ürün grupları, ürünler,
                  masalar, garsonlar — kalıcı olarak silinecek. Devam etmek istediğinize emin misiniz?
                </p>
                <div style={{ display: 'flex', gap: 10 }}>
                  <button onClick={() => setSilPopup(null)} className="btn btn-koyu" style={{ flex: 1 }}>Vazgeç</button>
                  <button onClick={silSonrakiAdim} className="btn btn-kirmizi" style={{ flex: 1 }}>Yine de Devam Et</button>
                </div>
              </>
            )}

            {silPopup.adim === 3 && (
              <>
                <h3 style={{ marginTop: 0, color: '#c0392b' }}>Son Onay</h3>
                <p style={{ fontSize: 14 }}>
                  <strong>"{silPopup.sablon.ad}"</strong> şablonunu <strong>kalıcı olarak</strong> silmek üzeresiniz.
                  Bu son onaydır, geri dönüş yoktur.
                </p>
                <div style={{ display: 'flex', gap: 10 }}>
                  <button onClick={() => setSilPopup(null)} className="btn btn-koyu" style={{ flex: 1 }}>Vazgeç</button>
                  <button onClick={kalicaSil} disabled={siliniyor} className="btn btn-kirmizi" style={{ flex: 1 }}>
                    {siliniyor ? 'Siliniyor...' : 'Evet, Kalıcı Olarak Sil'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
